import http from "./httpService";
import config from "../config.json";

const apiEndpoint = config.apiEndpoint + "/hall-of-fame";

export async function getHallOfFame(leagueId, seasonId) {
  const response = await http.get(
    apiEndpoint + "/" + leagueId + "/" + seasonId
  );
  return response.data;
}



// WEBPACK FOOTER //
// ./src/services/hallOfFameService.js